// extracted by mini-css-extract-plugin
export default {"wraper":"DayWraper_wraper__+OXhu","icon":"DayWraper_icon__RZiev","wiktor":"DayWraper_wiktor__QUegh"};